import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { PATHS } from 'router/config';
import { getFontFamily } from 'services/FontService';

interface IZoomTab {
  path: string;
  label: string;
}

const getZoomTabs = (t: TFunction): IZoomTab[] => [
  { path: PATHS.zoomDashboard, label: `${t('pages.zoom.tabs.dashboard')}` },
  { path: PATHS.zoomMatching, label: `${t('pages.zoom.tabs.matching')}` },
  { path: PATHS.zoomLessons, label: `${t('pages.zoom.tabs.lessons')}` },
  { path: PATHS.zoomRecordings, label: `${t('pages.zoom.tabs.recordings')}` },
  { path: PATHS.zoomAccounts, label: `${t('pages.zoom.tabs.accounts')}` },
  { path: PATHS.zoomSchedule, label: `${t('pages.zoom.tabs.schedule')}` },
  { path: PATHS.zoomAudit, label: `${t('pages.zoom.tabs.audit')}` },
];

export const ZoomTabs = () => {
  const { t } = useTranslation();
  return (
    <TabsBar>
      {getZoomTabs(t).map((tab) => (
        <TabLink key={tab.path} to={tab.path} activeClassName="active">
          {tab.label}
        </TabLink>
      ))}
    </TabsBar>
  );
};

const TabsBar = styled.nav`
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-top: 24px;
`;

const TabLink = styled(NavLink)`
  padding: 12px 0;
  font-family: ${getFontFamily('regular')};
  font-size: 14px;
  line-height: 22px;
  color: #6b7280;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: #111827;
  }

  &.active {
    color: #111827;
    border-bottom-color: #2563eb;
    font-family: ${getFontFamily('bold')};
  }
`;
